const rateLookUp = [
  {
    path: '/rateLookUp',
    name: 'RateLookUp',
    component: () => import(/* webpackChunkName: "rateLookUpPage" */ '@/modules-v2/rateLookUp/index'), // RateLookUpPage,
    meta: {
      title: 'Rate LookUp',
      requiresAuth: true,
    },
  },
];

export default rateLookUp;
